import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import {
  IAnnouncement,
  IAnnouncements,
  IAnnouncementsCount,
} from 'types/announcements'
import { IPaginationQueryInfo } from 'types/pagination'

type GetAnnouncementsInput = IPaginationQueryInfo & { tenderId: string }

export const announcementsApi = createApi({
  reducerPath: 'announcements',
  baseQuery,
  tagTypes: ['Announcements', 'AnnouncementsCount'],
  endpoints: (builder) => ({
    announcements: builder.query<IAnnouncements, GetAnnouncementsInput>({
      query: ({ page, size, tenderId }) => {
        return {
          url: '/announcements',
          method: 'get',
          params: {
            page,
            size,
            tenderId,
          },
        }
      },
      providesTags: ['Announcements'],
    }),
    announcementsCount: builder.query<IAnnouncementsCount, { tenderId: string }>({
      query: ({ tenderId }) => {
        return {
          url: `/announcements/${tenderId}/count-unread`,
          method: 'get',
        }
      },
      providesTags: ['AnnouncementsCount'],
    }),

    createAnnouncement: builder.mutation<void, Partial<IAnnouncement>>({
      query: (body) => ({
        url: `/announcements`,
        body,
        method: 'post',
      }),
      invalidatesTags: ['Announcements'],
    }),
  }),
})

export const {
  useAnnouncementsQuery,
  useAnnouncementsCountQuery,
  useCreateAnnouncementMutation,
} = announcementsApi
